import React from 'react';
import s from '../TierBadge.scss';
const Unlocked16 = ({ className  })=>/*#__PURE__*/ React.createElement("svg", {
        className: className,
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 16 16"
    }, /*#__PURE__*/ React.createElement("path", {
        d: "M7 0.57735C7.6188 0.220085 8.3812 0.220085 9 0.57735L13.9282 3.42265C14.547 3.77992 14.9282 4.44017 14.9282 5.1547V10.8453C14.9282 11.5598 14.547 12.2201 13.9282 12.5774L9 15.4226C8.3812 15.7799 7.6188 15.7799 7 15.4226L2.0718 12.5774C1.45299 12.2201 1.0718 11.5598 1.0718 10.8453V5.1547C1.0718 4.44017 1.45299 3.77992 2.0718 3.42265L7 0.57735Z",
        className: s['fill-color']
    }), /*#__PURE__*/ React.createElement("path", {
        d: "M12 6L11.1393 11.1644C11.0589 11.6466 10.6417 12 10.1529 12H5.84713C5.35829 12 4.9411 11.6466 4.86073 11.1644L4 6L6.5 7.5L8 4L9.5 7.5L12 6Z",
        className: s['bg-color']
    }));
Unlocked16.displayName = 'Unlocked16';
export default Unlocked16;
